const DepositTable = () =>
  import("@/components/TransactionsPage/DepositTable/index");
const WithdrawalTable = () =>
  import("@/components/TransactionsPage/WithdrawalTable/index");
const ExchangeTable = () =>
  import("@/components/TransactionsPage/ExchangeTable/index");
const transitionPage = () => import("@/components/transitionPage/index");
const TransactionDetail = () =>
  import("@/components/TransactionsPage/TransactionDetail/index");
import { mapActions } from "vuex";
import * as types from "@/store/types";
import { CurrenciesService } from "@/services";

export default {
  name: "transactions-page",
  components: {
    DepositTable,
    WithdrawalTable,
    ExchangeTable,
    transitionPage,
    TransactionDetail
  },
  props: [],
  data() {
    return {
      tab: 0
    };
  },
  computed: {},
  mounted() {
    this.getCurrenciesList();
  },
  methods: {
    ...mapActions({
      transactionOrderData:
        types.transactions.actions.ACTION_TRANSACTIONS_ORDER,
      setCurrencies: types.currencies.actions.SET_CURRENCIES,
      setFiltersStatus: types.transactions.actions.ACTION_TRANSACTIONS_STATUS
    }),
    getCurrenciesList() {
      CurrenciesService.getCurrencies().then(response => {
        this.setCurrencies(response.data.data);
      });
    }
  }
};
